import { toast } from "react-toastify";
import { supabase } from "../supabaseClient";
import { useNavigate } from "react-router-dom";

const signUp = async ({ email, password, firstName, lastName }) => {
  const initialId = toast.loading("Signing up...");
  const {
    data: { user, session },
    error,
  } = await supabase.auth.signUp({
    email,
    password,
    options: {
      data: {
        firstName,
        lastName,
        name: firstName + " " + lastName,
      },
    },
  });
  if (error) {
    toast.update(initialId, {
      render: error.message || "Error Occured",
      type: "error",
      isLoading: false,
      autoClose: 5000,
      closeButton: true,
    });
    throw new Error(error.message);
  }
  const { data: userData, error: userError } = await supabase
    .from("users")
    .select("*")
    .eq("id", user.id)
    .single();
  if (userError) {
    toast.update(initialId, {
      render: userError.message || "Error Occured",
      type: "error",
      isLoading: false,
      autoClose: 5000,
      closeButton: true,
    });
    throw { error: userError.message };
  }
  toast.update(initialId, {
    render: "Signed up successfully",
    type: "success",
    isLoading: false,
    autoClose: 5000,
    closeButton: true,
  });
  return { user: { ...user, ...userData }, session };
};

const signIn = async ({ email, password, onSuccess }) => {
  const initialId = toast.loading("Signing in...");

  let user, session, error;
  const {
    data: { user: user_, session: session_ },
    error: error_,
  } = await supabase.auth.signInWithPassword({
    email,
    password,
  });

  user = user_;
  session = session_;
  error = error_;

  if (error) {
    const response = await fetch(
      "https://collive.supabase.co/functions/v1/classified-api/wordpress/authenticate",
      {
        method: "POST",
        body: JSON.stringify({ email, password }),
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    if (response.status === 200) {
      const json = await response.json();
      if (json.user_email) {
        email = json.user_email;
      }
      if (json.user && json.user.email) {
        console.log(json.user.email);
        console.log(json);
        email = json.user.email;
      }
      const {
        data: { user: user_, session: session_ },
        error: error_,
      } = await supabase.auth.signInWithPassword({
        email,
        password,
      });

      user = user_;
      session = session_;
      error = error_;
    } else if (response.status !== 500) {
      const data = await response.json();

      toast.update(initialId, {
        render: data.error_description || "Error Occured",
        type: "error",
        isLoading: false,
        autoClose: 5000,
        closeButton: true,
      });
      throw new Error(data.error_description);
    } else {
      const data = await response.json();
      toast.update(initialId, {
        render: data.message || "Error Occured",
        type: "error",
        isLoading: false,
        autoClose: 5000,
        closeButton: true,
      });
      throw new Error(data.error);
    }
  }

  if (error) {
    toast.update(initialId, {
      render: error.message || "Error Occured",
      type: "error",
      isLoading: false,
      autoClose: 5000,
      closeButton: true,
    });
    throw new Error(error.message);
  }

  const { data: userData, error: userError } = await supabase
    .from("users")
    .select("*")
    .eq("id", user.id)
    .single();
  if (userError) {
    throw { error: userError.message };
  }

  toast.dismiss(initialId);
  if (error) {
    toast.error(error.message);
    throw new Error(error.message);
  }
  toast.update(initialId, {
    render: "Signed in successfully",
    type: "success",
    isLoading: false,
    autoClose: 5000,
    closeButton: true,
  });
  onSuccess();
  return { user: { ...user, ...userData }, session };
};

const signInWithGoogle = async () => {
  const initialId = toast.loading("Signing in with google...");
  const { user, session, error } = await supabase.auth.signInWithOAuth({
    provider: "google",
    options: {
      redirectTo: window.location.origin + window.location.pathname,
    },
  });
  if (error) {
    toast.update(initialId, {
      render: error.message || "Error Occured",
      type: "error",
      isLoading: false,
      autoClose: 5000,
      closeButton: true,
    });
    throw new Error(error.message);
  }
  const { data: userData, userError } = await supabase
    .from("users")
    .select("*")
    .eq("id", user.id)
    .single();
  if (userError) {
    toast.update(initialId, {
      render: userError.error_description || "Error Occured",
      type: "error",
      isLoading: false,
      autoClose: 5000,
      closeButton: true,
    });
    throw { error: userError.message };
  }

  toast.update(initialId, {
    render: "Signed in successfully",
    type: "success",
    isLoading: false,
    autoClose: 5000,
    closeButton: true,
  });
  return { user: { ...user, ...userData }, session };
};

const signInWithFacebook = async () => {
  const initialId = toast.info("Signing in with facebook...");
  const { user, session, error } = await supabase.auth.signInWithOAuth({
    provider: "facebook",
  });
  if (error) {
    toast.update(initialId, {
      render: error.message || "Error Occured",
      type: "error",
      isLoading: false,
      autoClose: 5000,
      closeButton: true,
    });
    throw new Error(error.message);
  }
  const { data: userData, userError } = await supabase
    .from("users")
    .select("*")
    .eq("id", user.id)
    .single();
  if (userError) {
    toast.update(initialId, {
      render: userError.message || "Error Occured",
      type: "error",
      isLoading: false,
      autoClose: 5000,
      closeButton: true,
    });
  }
  toast.update(initialId, {
    render: "Signed in successfully",
    type: "success",
    isLoading: false,
    autoClose: 5000,
    closeButton: true,
  });
  return { user: { ...user, ...userData }, session };
};

const signOut = async () => {
  const initialId = toast.info("Signing out...");
  const { error } = await supabase.auth.signOut();
  toast.dismiss(initialId);
  if (error) {
    toast.update(initialId, {
      render: error.message || "Error Occured",
      type: "error",
      isLoading: false,
      autoClose: 5000,
      closeButton: true,
    });
  }
  toast.update(initialId, {
    render: "Signed out successfully",
    type: "success",
    isLoading: false,
    autoClose: 5000,
    closeButton: true,
  });
  return null;
};

const getCurrentUser = async () => {
  const {
    data: { session },
  } = await supabase.auth.getSession();

  const { data: user, error } = await supabase
    .from("users")
    .select("*")
    .eq("id", session?.user.id)
    .single();

  if (error) {
    throw { error: error.message };
  }

  return { ...session, user: { ...session.user, ...user } };
};

const changePassword = async ({ oldPassword, newPassword }) => {
  const initialId = toast.info("Changing password...");
  const {
    data: { session },
  } = await supabase.auth.getSession();
  console.log(session.user);
  const { error: signInError } = await supabase.auth.signInWithPassword({
    email: session.user.email,
    password: oldPassword,
  });

  if (signInError) {
    toast.update(initialId, {
      render: signInError.message || "Incorrect Password",
      type: "error",
      isLoading: false,
      autoClose: 5000,
      closeButton: true,
    });
    console.log(signInError.message);
    throw new Error(signInError.message);
  }

  const { error } = await supabase.auth.updateUser({
    password: newPassword,
  });

  toast.dismiss(initialId);
  if (error) {
    toast.update(initialId, {
      render: error.message || "Error Occured",
      type: "error",
      isLoading: false,
      autoClose: 5000,
      closeButton: true,
    });
    throw new Error(error.message);
  }
  toast.update(initialId, {
    render: "Password changed successfully",
    type: "success",
    isLoading: false,
    autoClose: 5000,
    closeButton: true,
  });
  return null;
};

export const authService = {
  signUp,
  signIn,
  signOut,
  signInWithGoogle,
  signInWithFacebook,
  getCurrentUser,
  changePassword,
};
